import Action from '../../Action'
import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import MultiSelector from '../../MultiSelector';
const ModalAddNotificacion =({
      server,
      languaje,
      mode,
      setDataWorkFlow,
      dataWorkFlow,
      closeModal,
      SetElementList,
      elementsList,
      handleRemoveItem
})=>{
  const [disabled,setDisabled]=useState(true)


  const reqField=()=>{
      return(
        <p className='reqField-gs'>
          *
        </p>
      )
    }



  // const metricData=useFetch('cassia/user_groups','','','GET',server)
  // const metricData2=useFetch('cassia/media/telegram/groups','','','GET',server)

  const [metricData,setMetricData]=useState({data:[],loading:true,error:null})
  useEffect(()=>{
    buscar_datos()
  },[])
  const buscar_datos = () => {
    setMetricData({data:metricData.data,loading:true,error:null})
    const fetchDataPost = async () => {
      try {
       let url=""
       if(typeNoti=="1"){
        url="cassia/user_groups/"
       }else{
        url="cassia/media/telegram/groups/"
       }
        const response = await fetch(
          server.url +
            "/api/v1/"+url,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        // console.log(response);
        if (response.ok) {
          const data1 = await response.json();
          setMetricData({data:data1,loading:false,error:null})
          // setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
        //   console.log(data1);
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };

  const cancelItem=()=>{
    setDataWorkFlow((prevState)=>{
      return {
          ...prevState,
        ['interested_user_group_ids']:[]
      }
      
  })
  setDataWorkFlow((prevState)=>{
    return {
        ...prevState,
      ['telegram_groups']:[]
    }
    
})
  SetElementList((prevState)=>{
    return {
        ...prevState,
      ['notification']:""
    }
    
})
handleRemoveItem({ id: 'notification', label: capitalizeFirstLetter(lang[languaje]['notficacion']), type: 'notification' })
closeModal()
  }

  const changeMultiOption=(option,index,titulo)=>{
      let attr=""
      if(titulo=="Grupos"){
        attr="groupids"
      }
      if(typeNoti=="1"){
        setDataWorkFlow((prevState)=>{
          return {
              ...prevState,
            ['interested_user_group_ids']:option.map(item => item.value)
          }
          
      })
      }else{
        setDataWorkFlow((prevState)=>{
          return {
              ...prevState,
            ['telegram_groups']:option.map(item => item.value)
          }
          
      })
      }
      
SetElementList((prevState)=>{
  return {
      ...prevState,
    ['notification']:option.map(item => item.label).join(" - ")
  }
  
})
    }
  const [typeNoti,setTypeNoti]=useState(1)

  const handleChange=(e)=>{
    setTypeNoti(e.target.value)

    setDataWorkFlow((prevState)=>{
      return {
          ...prevState,
        ['interested_user_group_ids']:[]
      }
      
  })
    setDataWorkFlow((prevState)=>{
      return {
          ...prevState,
        ['telegram_groups']:[]
      }
      
  })
  }
  useEffect(()=>{
    buscar_datos()
  },[typeNoti])
  const {interested_user_group_ids}=dataWorkFlow;
  return(
      <div className="modal-GS-content">
          <div className='card-modal-gs modal-verificate'>
              <div className='head-card-modal-gs'>
                  <div className='title-head-card-modal-gs'>
                      {(lang[languaje]['agregar'].toUpperCase())+' '+lang[languaje]['grupos'].toUpperCase()}
                  </div>
              </div>
              <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
              
                                  <div className="form-GS-box"> 
                                  
                                  <div className="user-box-GS" style={{height:'20%'}}>
    
      <input
        required
        name="status"
        
        defaultChecked={true}
        className='checkbox-gs'
        type="radio"
        value="1"
        onChange={handleChange}
        style={{height:'20px !important',width:'30%'}}
      />
    
    <label className='label-checkbox-gs' style={{width:'70%',position:'relative',left:'unset'}}>{capitalizeFirstLetter(lang[languaje]['gruposUsuarios'])}</label>
    <input
        required
        name="status"
        
        className='checkbox-gs'
        type="radio"
        value="2"
        onChange={handleChange}
        style={{height:'20px !important',width:'30%'}}
      />
    
    <label className='label-checkbox-gs' style={{width:'70%',position:'relative',left:'unset'}}>{'Telegram'}</label>
  </div>
                                  <div className="user-box-GS "  style={{height:'50%'}}>
                                      {/* {
                                          (metricData.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                          <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(metricData==null)?0:metricData} origen={'Admin'} data={metricData.data.data}   loading={metricData.loading}  titulo='Event' selectFunction={changeOption} index={0}></SelectorAdmin>
                                      } */}
                                      {
                                        // (metricData=="1")?
                                        <>
                                        {
                                          (metricData.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                          <MultiSelector placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={''}  opt_de={[]} origen={'Admin'} data={metricData.data.data}   loading={metricData.loading}  titulo={(typeNoti=="1")?'Estados':'telegram'} selectFunction={changeMultiOption} index={0}></MultiSelector>
                                        }
                                        </>
                                        // :
                                        // <>
                                        // {
                                        //   (metricData2.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                        //   <MultiSelector placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={''}  opt_de={[]} origen={'Admin'} data={metricData2.data.data}   loading={metricData2.loading}  titulo='Estados' selectFunction={changeMultiOption} index={0}></MultiSelector>
                                        // }
                                        // </>
                                          
                                      }
                                      <label className='label-GS' style={{top:'2%'}}>{capitalizeFirstLetter((typeNoti=="1")?lang[languaje]['gruposUsuarios']:(lang[languaje]['grupos']+" Telegram"))}{(interested_user_group_ids.lenght==0)?reqField():''}</label>   
                                  </div>
                                  
                              
                                 
                                  
                                  
                                  <div className="user-box-GS" style={{height:'30%'}}>
                                      {
                                          
                                          <>
                                          <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={cancelItem}/>
                                          <Action disabled={(interested_user_group_ids.lenght==0?true:false)} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={closeModal}/>
                                          </>
                                          // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                      }
                                          
                                  {
                                      // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                  }
                                      
                                  </div>
                              </div>
              </div>
              </div>
      </div>
  )
}

export default ModalAddNotificacion